<div
    infinite-scroll
    [infiniteScrollDistance]="infiniteScrollDistance"
    [infiniteScrollThrottle]="infiniteScrollThrottle"
    [fromRoot]="true"
    [infiniteScrollContainer]="scrollContent"
    (scrolled)="onScrollDown()"
>
    <ng-content />
</div>
